module.exports = __webpack_public_path__ + "static/undraw_choose_80qg.38b2be3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/graphics/undraw_choose_80qg.svg
// module id = 488
// module chunks = 33781710060979